import _ from 'lodash'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { getPapamFrom, updateOldValue } from '../../lib/processPortalRules'

export const recursivePreparePortalSFMapping = (sfList, state, currParams, messages, isChild) => {
  let result = {}
  const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
  _.each(sfList, function (sfItem, uid) {
    let item = {}
    let isValidIntegration = true
    _.each(sfItem.fields, function (field) {
      if (field && field.value) {
        let val
        if (_.startsWith(field.group, 'listWidget:')) {
          val = _.get(state, String(field.value).replace(/:/g, '.'), '')
        } else if (_.startsWith(field.group, 'formWidget:')) {
          val = _.get(state, String(field.value).replace(/:/g, '.'), '')
        } else if (field.group === 'smartv') {
          if (!isUserSignIn) {
            isValidIntegration = false
          }
          val = _.get(getPreviewDynamicData(), `svParams.${field.value}`, '')
        } else if (_.startsWith(field.group, 'form:')) {
          val = _.get(state, field.value, null)
        } else if (field.group === 'params' || field.group === 'param' || field.group.indexOf('params') !== -1) {
          if (field.group.indexOf('params') !== -1) {
            val = getPapamFrom(currParams, _.last(field.value.split('.')))
          } else {
            val = getPapamFrom(currParams, field.value)
          }
        } else if (_.startsWith(field.group, 'view:')) {
          val = _.get(state, String(updateOldValue(field.value)).replace(/:/g, '.'), '')
        } else {
          val = _.get(state, String(field.value).replace(/:/g, '.'), '')
        }
        if (isChild && !val && val !== false) {
          isValidIntegration = false
        }
        item[field.group + '#-#' + field.value] = val
      }
    })

    if (sfItem.childrens && isValidIntegration) {
      item.childrens = {
        list: recursivePreparePortalSFMapping(sfItem.childrens, state, currParams, messages, false),
      }
    }

    if (isValidIntegration || !isChild) {
      if (sfItem.loadingMessage) {
        messages.push(sfItem.loadingMessage)
      }
      result[uid] = item
    }
  })
  return result
}
